export const SHARE_ERROR = 'Compartilhamento não disponível.'
